/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>

        <path d="M19.9084993,20.6149993 L20.6164993,19.9089993 L16.3354993,15.6279993 C18.8124993,12.7689993 18.5834993,8.46199928 15.8144993,5.88399928 C13.0464993,3.30599928 8.73249927,3.38299928 6.05749927,6.05799928 C3.38349927,8.73299928 3.30549927,13.0449993 5.88449927,15.8139993 C8.46249927,18.5819993 12.7694993,18.8129993 15.6284993,16.3349993 L19.9084993,20.6149993 Z M11.0524993,17.0519993 C7.73849927,17.0519993 5.05249927,14.3649993 5.05249927,11.0519993 C5.05249927,7.73799928 7.73849927,5.05199928 11.0524993,5.05199928 C14.3664993,5.05199928 17.0524993,7.73799928 17.0524993,11.0519993 C17.0494993,14.3639993 14.3644993,17.0489993 11.0524993,17.0519993 Z" className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'SearchIcon';

export default Icon;
